"use client";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

/**
 * Custom hook to apply tenant colors globally via CSS custom properties
 * This hook automatically updates CSS variables when tenant colors change
 */
export const useGlobalTheme = () => {
  const tenant = useSelector((state: RootState) => state.tenant);

  useEffect(() => {
    // Apply primary color
    if (tenant.primary_color) {
      document.documentElement.style.setProperty(
        "--tenant-primary",
        tenant.primary_color
      );
    }

    // Apply secondary color (use first secondary color if available)
    if (tenant.secondary_colors && tenant.secondary_colors.length > 0) {
      document.documentElement.style.setProperty(
        "--tenant-secondary",
        tenant.secondary_colors[0]
      );
    }

    // Apply additional secondary colors if needed
    tenant.secondary_colors?.forEach((color, index) => {
      document.documentElement.style.setProperty(
        `--tenant-secondary-${index + 1}`,
        color
      );
    });
  }, [tenant.primary_color, tenant.secondary_colors]);

  return {
    primaryColor: tenant.primary_color,
    secondaryColors: tenant.secondary_colors,
    tenant,
  };
};
